import React from 'react';

import part1 from '../../../imgs/Cup-Case.webp';


const Applicaticase = () => {
    return (
        <div className='container'>
            <div className="">
                <div className="applifon" style={{ textAlign: 'center' }}>
                    <img src={part1} alt="Part 1" className="applifon-img"  style={{ width: '56%', paddingBottom: '13px' }} />
                </div>

            </div>
        </div>
    );
}

export default Applicaticase;
